export const syllabusData = [
  {
    no: 1,
    title: "Dasar Data & Analytics (Conceptual Foundation)",
    source: "https://www.coursera.org/learn/dasar-dasar-analitik-data-data-data-di-mana-mana#modules",
    outcomes: [
      "Menentukan dan menjelaskan konsep utama yang terlibat dalam analitik data termasuk data, analisis data, dan ekosistem data",
      "Menjelaskan fungsi aplikasi spreadsheet, bahasa kueri, dan visualisasi data pada analitik data",
      "Melakukan penilaian mandiri dengan cara berpikir analitis melalui contoh penerapan pola pikir analitis",
      "Menjelaskan peran seorang analis data bila dikaitkan dengan pekerjaan/posisi tertentu"
    ]
  },
  {
    no: 2,
    title: "Types of Data Analytics (Descriptive, Diagnostic, Predictive, Prescriptive)",
    source: "https://www.coursera.org/articles/descriptive-predictive-and-prescriptive-analytics",
    outcomes: ["Menjelaskan tipe tipe data analisis"]
  },
  {
    no: 3,
    title: "Data Lifecycle (Collection, Cleanup, Visualization, Reporting)",
    source: "https://www.coursera.org/learn/data-preparation-and-management?utm_source=chatgpt.com",
    outcomes: ["Membahas mulai dari data sources (mirip dengan collection), data transformation/cleanup, data storage, hingga mempersiapkan data untuk visualization/reporting"]
  },
  {
    no: 4,
    title: "Statistik Deskriptif & Dasar Statistik",
    source: "https://www.coursera.org/learn/statistical-methods-and-data-analysis-1",
    outcomes: ["Menjelaskan konsep statistik dasar termasuk distribusi & korelasi"]
  },
  {
    no: 5,
    title: "Distribusi Data & Korelasi Dasar",
    source: "https://www.coursera.org/learn/basic-statistics",
    outcomes: ["Memahami konsep dasar distribusi data termasuk ukuran pemusatan dan penyebaran, menyajikan data dalam bentuk tabel dan visualisasi seperti histogram, boxplot, serta scatter plot untuk mengidentifikasi pola distribusi, menganalisis karakteristik data termasuk outlier, memahami dan menjelaskan konsep korelasi serta jenis hubungan antar variabel, menghitung dan menafsirkan nilai korelasi menggunakan alat bantu statistik, dan menggunakan hasil analisis distribusi dan korelasi untuk menarik insight serta mendukung pengambilan keputusan berbasis data secara efektif dan komunikatif."]
  },
  {
    no: 6,
    title: "Excel untuk Data Analysis (Data Cleaning & Formula Dasar)",
    source: "https://www.coursera.org/learn/excel-data-analysis-fundamentals",
    outcomes: ["Menggunakan tools dan fungsi Excel untuk membersihkan serta menyiapkan data untuk analisis, memanfaatkan Named Ranges dan Tables untuk mengotomatisasi analisis, memahami berbagai jenis data di Excel dan menerapkan fungsi yang sesuai, serta menggunakan fungsi logika dan lookup untuk mentransformasi, menghubungkan, dan mengelompokkan data"]
  },
  {
    no: 7,
    title: "Excel: Lookup, Date Function & Pivot Table",
    source: "https://www.coursera.org/learn/excel-basics-data-analysis-ibm",
    outcomes: ["Menguasai penggunaan fungsi dasar Excel seperti berbagai fungsi lookup (termasuk VLOOKUP dan fungsi pencarian lainnya) untuk menghubungkan dan mengambil data secara efisien, mengelola dan memproses data dengan teknik dasar yang tepat, serta memahami dan membuat Pivot Tables untuk menganalisis data secara cepat dan menyajikan ringkasan informasi yang dapat membantu pengambilan keputusan."]
  },
  {
    no: 8,
    title: "SQL & Data Collection (Basic SQL, Data Sources, Workflow)",
    source: "https://www.coursera.org/learn/sql-for-data-science?utm_source=chatgpt.com",
    outcomes: ["Mengidentifikasi subset data dari satu atau beberapa kolom dan menuliskannya dalam kueri SQL, menggunakan perintah SQL untuk memfilter, mengurutkan, dan merangkum data, menggabungkan hasil beberapa kueri dengan operator UNION, serta memanipulasi data teks, tanggal, dan numerik menggunakan fungsi SQL agar data dari berbagai sumber dapat terintegrasi dan siap dianalisis"]
  },
  {
    no: 9,
    title: "Data Cleaning & Transformation (Missing Data, Outlier, Transformation)",
    source: "https://www.coursera.org/learn/google-clean-your-data",
    outcomes: ["Mengeksplorasi praktik EDA yang meliputi pembersihan, validasi, dan penggabungan data"]
  },
  {
    no: 10,
    title: "Exploratory Data Analysis (EDA) dengan Python",
    source: "https://www.coursera.org/projects/exploratory-data-analysis-python-pandas",
    outcomes: ["Menerapkan teknik Exploratory Data Analysis (EDA) secara praktis pada dataset tabular menggunakan Python (seperti Pandas dan NumPy), serta menghasilkan visualisasi data menggunakan Seaborn dan Matplotlib"]
  },
  {
    no: 11,
    title: "Data Visualization (Prinsip Chart & Tools)",
    source: "https://www.coursera.org/learn/foundations-of-data-visualization",
    source2: "https://www.coursera.org/learn/visualize-data",
    outcomes: [
      "Memahami konsep dan prinsip visualisasi data, memilih grafik yang sesuai dengan jenis data, serta menerapkan persepsi visual dan desain yang jelas, sederhana, dan efektif untuk mendukung pengambilan keputusan dan storytelling",
      "Menjelaskan penggunaan visualisasi data untuk menyampaikan data dan hasil analisis, mengenali Tableau sebagai alat visualisasi data beserta kegunaannya, memahami konsep data-driven storytelling termasuk pentingnya dan karakteristiknya, serta menjelaskan prinsip dan praktik dalam menyusun presentasi yang efektif"
    ]
  },
  {
    no: 12,
    title: "Machine Learning Basic (Supervised & Unsupervised)",
    source: "https://www.coursera.org/learn/machine-learning",
    source2: "https://www.coursera.org/learn/ibm-unsupervised-machine-learning",
    outcomes: [
      "Membangun dan melatih model machine learning supervised di Python menggunakan NumPy dan scikit-learn untuk tugas prediksi dan klasifikasi (regresi linear dan logistik)",
      "Mengenalkan unsupervised learning, yaitu pembelajaran mesin tanpa data berlabel, untuk menemukan pola dan insight melalui teknik clustering dan reduksi dimensi"
    ]
  },
  {
    no: 13,
    title: "Business Understanding & Analytical Thinking",
    source: "https://www.coursera.org/learn/google-introducing-data-analytics-and-analytical-thinking",
    outcomes: ["Menjelaskan peran data dalam keputusan sehari-hari, tahapan proses analisis data, konsep dasar analitik data, serta penerapan pengambilan keputusan berbasis data melalui contoh"]
  },
  {
    no: 14,
    title: "Advanced Excel for Data Analyst",
    source: "https://www.coursera.org/learn/mq-statistics-and-data-analysis-with-excel-advanced",
    outcomes: ["Merancang visualisasi data interaktif di Excel, memanfaatkan fungsi Excel dan Data Analysis ToolPak, menganalisis data dengan teknik statistik lanjutan, serta membuat forecast untuk menghasilkan insight yang dapat ditindaklanjuti"]
  },
  {
    no: 15,
    title: "SQL for Analytics (Intermediate & Window Functions)",
    source: "https://www.coursera.org/projects/sql-window-functions-for-analytics",
    outcomes: ["Mempelajari penggunaan SQL Window Functions untuk analitik, termasuk fungsi ranking, paging, agregasi, dan grouping (ROW_NUMBER, RANK, NTILE, OVER, ROLLUP, CUBE) guna menghasilkan insight dari database"]
  },
  {
    no: 16,
    title: "A/B Testing for Data Analyst",
    source: "https://www.coursera.org/learn/beyond-basics-advanced-data-analysis-with-python",
    outcomes: ["Mempelajari metode statistik lanjutan seperti uji hipotesis dan A/B testing, serta otomatisasi analisis data melalui studi kasus nyata untuk menyelesaikan masalah bisnis kompleks"]
  },
  {
    no: 17,
    title: "Dashboarding & Data Storytelling",
    source: "https://www.coursera.org/learn/dlai-data-storytelling",
    outcomes: ["Merancang visualisasi dan dashboard untuk menyampaikan insight secara efektif, mempresentasikan hasil analisis kepada stakeholder sesuai tujuan bisnis, serta membangun CV, portofolio, dan strategi pencarian kerja sebagai data analyst"]
  },
  {
    no: 19,
    title: "Mathematics for Data Science",
    source: "https://www.coursera.org/specializations/mathematics-for-machine-learning-and-data-science",
    outcomes: ["Memahami dasar matematika di balik algoritma machine learning serta teknik statistik untuk meningkatkan kualitas dan insight dari analisis data"]
  },
  {
    no: 20,
    title: "Statistics & Probability (Advanced)",
    source: "https://www.coursera.org/learn/machine-learning-probability-and-statistics",
    outcomes: ["Memahami dan mengukur ketidakpastian prediksi model machine learning, konsep distribusi probabilitas, serta mengevaluasi kinerja model secara statistik"]
  },
  {
    no: 21,
    title: "Econometrics Fundamentals",
    source: "https://www.coursera.org/learn/erasmus-econometrics",
    outcomes: ["Econometrics merupakan course cara menerjemahkan data menjadi model statistik untuk analisis, peramalan, dan pengambilan keputusan, dengan materi seperti regresi, time series, dan variabel biner"]
  },
  {
    no: 22,
    title: "Regression, Time Series & Distribution",
    source: "https://www.coursera.org/learn/modeling-time-series-and-sequential-data",
    outcomes: ["Membahas time series & distribution"]
  },
  {
    no: 23,
    title: "Advanced Coding for Data Science (Python & SQL)",
    source: "https://www.coursera.org/specializations/data-science-fundamentals-python-sql?utm_source=chatgpt.com",
    outcomes: ["Memiliki pemahaman kerja terhadap tools data science seperti Jupyter Notebooks, RStudio, GitHub, dan Watson Studio, menguasai dasar pemrograman Python mencakup struktur data, logika pemrograman, pengolahan file, pemanggilan API, serta penggunaan library Pandas dan NumPy, memahami teknik analisis statistik seperti statistik deskriptif, visualisasi data, distribusi probabilitas, uji hipotesis, dan regresi, serta menguasai dasar-dasar basis data relasional termasuk penggunaan SQL, perintah SELECT, pengurutan dan penyaringan data, fungsi database, serta pengolahan data dari beberapa tabel"]
  },
  {
    no: 24,
    title: "Advanced Machine Learning (Ensemble & Boosting)",
    source: "https://www.coursera.org/learn/modeling-time-series-and-sequential-data",
    outcomes: ["Kursus ini membahas pemodelan dan peramalan time series menggunakan pendekatan statistik klasik (ARIMA/ARIMAX), Bayesian, dan machine learning, termasuk teknik ensemble untuk meningkatkan akurasi prediksi, yang relevan bagi analis data dan data scientist"]
  },
  {
    no: 25,
    title: "Deep Learning (CNN, RNN, LSTM, Transformer, TL)",
    source: "https://www.coursera.org/specializations/deep-learning",
    source2: "https://www.coursera.org/learn/deep-learning-rnn-lstm-stock-price-prediction",
    outcomes: ["Mempelajari tentang deep learning beserta dengan beberapa modelnya seperti CNN, RNN, LSTM & Transformer"]
  },
  {
    no: 26,
    title: "MLOps (Deployment, CI/CD, Monitoring)",
    source: "https://www.coursera.org/learn/pearson-learn-mlops-for-machine-learning-video-training-xcgjr",
    outcomes: ["Mengenal MLOps dan membangun pipeline dasar end-to-end dengan tools open-source untuk deployment, CI/CD, monitoring, dan automasi model machine learning"]
  }
];
